const tab = {
    state: {
        currentMenu: null,
        tabsList: []
    },

    getters: {
        getMainTabList: state => {
            let tabsList = JSON.parse(sessionStorage.getItem('main_tab_list'))
            if (tabsList !== null) {
                state.tabsList = tabsList
            }
            return state.tabsList;
        },
    },

    mutations: {
        CHANGE_TO_TAB(state, val) {
            state.currentMenu = val
            let sampleVal = {
                fullPath: val.fullPath,
                name: val.name,
                path: val.fullPath || val.path,
                meta: val.meta,
                params: val.params || {},
                query: val.query || {}
            }
            if ('/home' == sampleVal.path) { //无首页 显示的空页面
                return;
            }
            let tabsList = JSON.parse(sessionStorage.getItem('main_tab_list')) || [];
            if ('首页' == sampleVal.meta.title) {
                tabsList[0] = sampleVal;
            } else {
                let tmp_path = sampleVal.path;
                let idx = sampleVal.path.indexOf('?');
                if (-1 != idx) {
                    tmp_path = sampleVal.path.substring(0, idx);
                }
                // let result = tabsList.findIndex(item => item.path == sampleVal.path)
                let result = tabsList.findIndex(item => item.path.toLowerCase().startsWith(tmp_path.toLowerCase()))
                if (-1 == result) {
                    tabsList.push(sampleVal)
                } else {
                    tabsList[result] = sampleVal;
                }
            }
            state.tabsList = tabsList;
            sessionStorage.setItem('main_tab_list', JSON.stringify(state.tabsList))
        },

        //关闭标签
        CLOSE_TAB_ONE(state, val) {
            let result = state.tabsList.findIndex(item => item.path == val.path)
            state.tabsList.splice(result, 1)
            sessionStorage.setItem('main_tab_list', JSON.stringify(state.tabsList))
        },

        // 全部关闭
        CLOSE_TAB_ALL(state) {
            // 第一个首页的话 不关闭
            if (state.tabsList[0] && state.tabsList[0].meta && '首页' == state.tabsList[0].meta.title) {
                state.tabsList.splice(1, state.tabsList.length - 1);
            } else {
                state.tabsList.splice(0, state.tabsList.length);
            }
            sessionStorage.setItem('main_tab_list', JSON.stringify(state.tabsList))
        },

        // 关闭右侧
        CLOSE_TAB_RIGHT(state, val) {
            for (let i = state.tabsList.length - 1; i > -1; i--) {
                let item = state.tabsList[i];
                if (item.path == val.path) {
                    break;
                } else {
                    state.tabsList.splice(i, 1);
                }
            }
            sessionStorage.setItem('main_tab_list', JSON.stringify(state.tabsList))
        },

        // 关闭其他
        CLOSE_TAB_OTHER(state, val) {
            if ('首页' == val.meta.title) {
                state.tabsList = [state.tabsList[0]];
            } else {
                let currItem = state.tabsList.find((item) => {
                    return item.path == val.path;
                })
                if ('首页' == state.tabsList[0].meta.title) {
                    state.tabsList = [state.tabsList[0], currItem];
                } else {
                    state.tabsList = [currItem];
                }
            }
            sessionStorage.setItem('main_tab_list', JSON.stringify(state.tabsList))
        },
    },

}

export default tab